import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';

export default class Bat extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.batSprite = this.scene.add.sprite(0, 0, ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._bat_animation_0);
    this.batSprite.setPosition(-this.batSprite.width / 2, -this.batSprite.height / 2);
    this.add(this.batSprite);
    this.batSprite.play('Bat_loop');
  }
}